export default __webpack_public_path__ + "static/media/hop04.ba9d2016.png";